var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcNavArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.60983 3.57413C1.75628 3.42768 1.99372 3.42768 2.14017 3.57413L6 7.43396L9.85984 3.57413C10.0063 3.42768 10.2437 3.42768 10.3902 3.57413C10.5366 3.72057 10.5366 3.95801 10.3902 4.10446L6.26517 8.22946C6.11872 8.37591 5.88128 8.37591 5.73484 8.22946L1.60983 4.10446C1.46339 3.95801 1.46339 3.72057 1.60983 3.57413Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNavArrowDown);
export default __webpack_public_path__ + "static/media/ic_nav_arrow_down.ae5755ca1ced0e5bf426e7fc2f20b921.svg";
export { ForwardRef as ReactComponent };